import { defineMessages } from 'react-intl'

export default defineMessages({
    deadlineFar: {
        id: 'components.datatable.timestampStatus.deadlineFar',
        defaultMessage: 'Deadline is not within the next 24 hours',
    },
    deadlineClose: {
        id: 'components.datatable.timestampStatus.deadlineClose',
        defaultMessage: 'Close to deadline!',
    },
    deadlinePassed: {
        id: 'components.datatable.timestampStatus.deadlinePassed',
        defaultMessage: 'Deadline passed',
    },
    timestampUnknown: {
        id: 'components.datatable.timestamp.unknown',
        defaultMessage: 'Unknown',
    }
})
